module.exports = __webpack_public_path__ + "static/media/step-by-step-iphone.43e3c907.webp";